import { Box, Heading, Stack, Text } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import * as React from "react";

const formIds = {
  1: "student-details",
  2: "teacher-selection",
  3: "lesson-schedule",
  4: "lesson-location",
  5: "contact-information",
};

type FormWrapperProps = {
  children: React.ReactNode;
  activeForm: number;
  bgColor?: string;
  customFormIds?: any;
  [key: string]: any;
};

const FormWrapper: React.FC<FormWrapperProps> = observer(
  ({
    children,
    customFormIds = formIds,
    activeForm = 1,
    bgColor = "neutral.200",
    ...rest
  }) => {
    return (
      <Box bg={["white", bgColor]} {...rest}>
        {React.Children.map(children, (child, index) => {
          const spacingProps = { pt: [12, 8], pb: [6, 12] };
          if (index + 1 < activeForm) {
            return React.cloneElement(child as any, {
              id: customFormIds[index + 1],
              formNo: index + 1,
            });
          } else if (index + 1 === activeForm) {
            return React.cloneElement(child as any, {
              id: customFormIds[index + 1],
              formNo: index + 1,
              ...(index !== 0 && spacingProps),
            });
          } else {
            return React.cloneElement(child as any, {
              formNo: index + 1,
              id: customFormIds[index + 1],
              display: "none",
            });
          }
        })}
      </Box>
    );
  }
);

export default FormWrapper;

type FormContainerProps = {
  heading: string;
  description: string;
  children: any;
  Component?: any;
  [key: string]: any;
};

export const FormContainer: React.FC<FormContainerProps> = ({
  heading,
  description,
  children,
  Component,
  ...rest
}) => {
  return (
    <Box pt={[0, 16]} pb={[0, 8]} {...rest}>
      <Box rounded="fbRadius" bg="white" shadow={["none", "fbShadow"]}>
        <Stack spacing={6} px={[5, 6, 10, 10, 20]} py={[10, 10, 12, 12]}>
          <Stack spacing={3}>
            <Heading fontWeight="extrabold">{heading}</Heading>
            <Text fontSize="lg" opacity={0.9} lineHeight="tall">
              {description}
            </Text>
          </Stack>

          {children}
        </Stack>
      </Box>
    </Box>
  );
};
